import React from 'react';

export type KeywordChipVariant = 'primary' | 'secondary' | 'mini';

export interface KeywordChipProps {
  variant?: KeywordChipVariant;
  children: React.ReactNode;
  title?: string;
}

const VARIANT_STYLES: Record<KeywordChipVariant, React.CSSProperties> = {
  primary: {
    height: 20,
    padding: '0 8px',
    borderRadius: 4,
    fontSize: 11,
    background: 'var(--color-coral-light)',
    color: 'var(--color-coral-dark)',
    fontWeight: 600,
    border: '1px solid rgba(217,119,6,0.18)',
  },
  secondary: {
    height: 20,
    padding: '0 8px',
    borderRadius: 4,
    fontSize: 11,
    background: 'var(--color-paper-2)',
    color: 'var(--color-ink-2)',
    fontWeight: 500,
    border: '1px solid var(--color-warm-border)',
  },
  mini: {
    height: 16,
    padding: '0 6px',
    borderRadius: 3,
    fontSize: 10,
    background: 'var(--color-paper-2)',
    color: 'var(--color-ink-3)',
    fontWeight: 600,
    border: '1px solid var(--color-warm-border)',
  },
};

export const KeywordChip: React.FC<KeywordChipProps> = ({
  variant = 'secondary',
  children,
  title,
}) => {
  return (
    <span
      title={title}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        ...VARIANT_STYLES[variant],
      }}
    >
      {children}
    </span>
  );
};

export default KeywordChip;
